class USProofgradeShipping extends HTMLElement {
    constructor() {
        super();
        this.cartHeader = this.closest('.cart-header');
        this.wrapper = this.querySelector('.pg-free-shipping-wrapper');
        this.titleBefore = this.querySelector('.title__wrapper .title-before');
        this.titleAfter = this.querySelector('.title__wrapper .title-after');
        this.threshold = this.dataset.proofgradeThreshold;
    }

    async getCountry() {
        const GEOLOCATION_API = 'https://glowforge.com/dotcom/api/geolocation';
        return fetch(GEOLOCATION_API)
            .then(result => {
                if (result.status === 200) {
                    return result.json();
                }
                throw new Error(`Failed to get request, geoloc api returned ${result.status} ${result.statusText}`);
            })
            .then(data => data.country)
            .catch(error => {
                console.error('Error fetching country:', error);
                return null;
            });
    };

    initialBannerShow() {
        this.classList.remove('hidden');
    };
    toggleMessaging() {
        const cart_header_content = this.cartHeader?.querySelector('.header-content .cart__totals');
        cart_header_content?.dataset?.isProofgradePresent == 'false' ? this.classList.add('hidden') : this.classList.remove('hidden')
        if (+cart_header_content?.dataset?.cartProofgradeTotal >= +this.threshold) {
            this.titleBefore?.classList.add('hidden');
            this.titleAfter?.classList.remove('hidden');
        } else {
            this.titleBefore?.classList.remove('hidden');
            this.titleAfter?.classList.add('hidden');
        }
    }

    async connectedCallback() {
        const country = await this.getCountry();
        if (country && country == "US") {
            this.initialBannerShow();
            if (this.cartHeader) {
                this.toggleMessaging();
                document.addEventListener('custom:cart:updated', () => this.toggleMessaging());
            }
        }
    }
}

if (!window.customElements.get("us-proofgrade-shipping")) {
    window.customElements.define("us-proofgrade-shipping", USProofgradeShipping);
}